// extracted by mini-css-extract-plugin
module.exports = {"spinner":"GrossMargin_spinner__1Bu_g"};